"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/CreateNew/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _user = require('shared/selectors/user');
var _hooks = require('web/services/hooks');

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _CreateNewVideo = require('./CreateNewVideo'); var _CreateNewVideo2 = _interopRequireDefault(_CreateNewVideo);









var CreateNewTypes; (function (CreateNewTypes) {
  const VIDEO = "VIDEO"; CreateNewTypes["VIDEO"] = VIDEO;
})(CreateNewTypes || (exports.CreateNewTypes = CreateNewTypes = {}));

const resolveModalTitle = (type) => {
  const types = {
    [CreateNewTypes.VIDEO]: 'Start a video chat',
  }

  return type && types[type] || 'Create New'
}

const CreateNew = ({
  open,
  onClose,
  selectedTab,
  children,
  title,
}) => {
  const hasVideoFeature = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserHasVideoV1Feature)
  const content = children || (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_CreateNewVideo2.default, {
        visible: selectedTab === CreateNewTypes.VIDEO,
        hasVideoFeature: hasVideoFeature, __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
      )
    )
  )

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: open,
      onClose: onClose,
      title: title || resolveModalTitle(selectedTab), __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}

      ,  content 
    )
  )
}

exports. default = _react.memo.call(void 0, CreateNew)
